import { gql } from "@apollo/client";

export const GET_ORGANIZATION_ACCOUNTS = gql`
  query SpendOrganizationAccounts {
    spendOrganizationAccounts {
      accounts {
        available
        balance
        id
        name
        status
        type
        groupStatus
        groupId
      }
      count
      groupsBalance {
        active
        archived
      }
      totalBalance
    }
  }
`;

export const ORGANIZATION = gql`
  query SpendOrganization {
    spendOrganization {
      id
      userId
      legalName
      nickname
      orgId
      accountId
      city
      state
      street
      street2
      zip
      groups {
        name
        id
        isArchived
        accountId
      }
      owner {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_ORG_BANK_ACCOUNTS = gql`
  query SpendOrganizationBankAccounts {
    spendOrganizationBankAccounts {
      externalAccounts {
        accountId
        availableBalance
        currentBalance
        mask
        name
        officialName
        subtype
        type
        institution {
          id
          name
        }
      }
      status
    }
  }
`;

export const GET_ORG_ACCOUNT_LIMITS = gql`
  query SpendOrganizationAccountLimits($groupId: String) {
    spendOrganizationAccountLimits(groupId: $groupId) {
      ach {
        limits {
          dailyDebit
          dailyCredit
          monthlyDebit
          monthlyCredit
        }
      }
      bookTransfer {
        limits {
          dailyDebit
          dailyCredit
          monthlyDebit
          monthlyCredit
        }
      }
      card {
        limits {
          dailyWithdrawal
          dailyDeposit
          dailyPurchase
          dailyCardTransaction
        }
      }
      checkDeposit {
        limits {
          daily
          monthly
        }
      }
      wire {
        limits {
          dailyTransfer
          monthlyTransfer
          dailyTransferSoft
          monthlyTransferSoft
        }
      }
      checkPayment {
        limits {
          dailySent
          monthlySent
        }
      }
    }
  }
`;
export const GET_ALL_CUSTOMER_CARDS = gql`
  query SpendOrganizationAllActiveCustomerCards {
    spendOrganizationAllActiveCustomerCards {
      cards {
        id
        lastFour
        expiration
        status
        userId
        groupOrOrgName
        userName
      }
      count
    }
  }
`;

export const GET_PAYEE_BY_ID = `
  query SpendGetPayeeById($spendGetPayeeByIdId: String!) {
    spendGetPayeeById(id: $spendGetPayeeByIdId) {
      einNumber
    }
  }
`;

export const GET_COUNTERPARTY_BY_ID = `
  query SpendGetCounterpartyById($counterpartyId: String!) {
    spendGetCounterpartyById(counterpartyId: $counterpartyId) {
      einNumber
    }
  }
`;

export const GET_ORG_COUNTERYPARTIES = gql`
  query SpendGetOrganizationCounterparties($groupOrOrgId: String!) {
    spendGetOrganizationCounterparties(groupOrOrgId: $groupOrOrgId) {
      counterparties {
        id
        name
        bankName
        accountLastFour
        routingNumber
        einNumber
      }
    }
  }
`;
export const GET_ORG_PAYEES = gql`
  query SpendOrganizationPayees($orgId: String!) {
    spendOrganizationPayees(orgId: $orgId) {
      payees {
        id
        name
        address1
        address2
        city
        state
        zipCode
        einNumber
      }
    }
  }
`;

export const GET_ORGANIZATION_DEBIT_CARDS = gql`
  query SpendOrganizationDebitCards {
    spendOrganizationDebitCards {
      cards {
        expiration
        id
        lastFour
        status
        userId
      }
      count
    }
  }
`;
